import { CombinedOptions, DefaultParamType, useTranslate } from '@tolgee/react';
import { useMemoizedFn } from 'ahooks';
import { isMasterOnline, isQuickChat, isSiteGiant, isTfsoftware } from 'productLine';
import { isGreatChatDemoChannel } from 'services/chattt';

export const getAppProductName = () =>
  isQuickChat
    ? 'QikChat'
    : isTfsoftware
    ? 'TF TALK++'
    : isMasterOnline
    ? 'MO Chatplus AI'
    : isSiteGiant
    ? 'SiteGiant AI-Chat'
    : isGreatChatDemoChannel
    ? 'Great Chat'
    : 'ChatPlusAI';

export function useTransAppProductName(ns?: string[]) {
  const { t } = useTranslate(ns);

  return useMemoizedFn((key: string, options?: CombinedOptions<DefaultParamType>) => {
    return t(key, {
      ...options,
      appProductName: getAppProductName(),
    });
  });
}
